declare namespace $ {

	export class $mol_icon_format_list_bulleted extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=bulleted.view.tree.d.ts.map